var Tickets = {

	lock: false,
	loading: false,
	// Create
	create: function () {
		$('#ticketForm').submit(function (e) {
			e.preventDefault();
			if (!Tickets.lock) {
				Tickets.lock = true;
				Api.post('/tickets/create', {
						title: $('#ticket_title').val(),
						message: $('#ticket_message').val(),
						department: $('#ticket_department').val()
					}, function (r) {
						if (r.success) {
							window.location.href = '/support/ticket/'+ r.ticket_id;
						} else {
							switch(r.error.identifier) {
								case 'message_is_required':
									Alert.push([{
										type: 'danger',
										text: '¡Oops! Debes ingresar una explicación.',
										icon: 'triangle-alert'
									}]);
									break;
								case 'title_is_required':
									Alert.push([{
										type: 'danger',
										text: '¡Oops! El asunto es un campo requerido.',
										icon: 'triangle-alert'
									}]);
									break;
								case 'department_not_found':
									Alert.push([{
										type: 'danger',
										text: '¡Oops! No has seleccionado un departamento válido.',
										icon: 'triangle-alert'
									}]);
									break;
							}
						}
						Tickets.lock = false;
				});
			}
		});
	},
	// Initialize
	init: function (id) {

		function putComment(c) {
			Language.get([
				'achievements.' + c.achievement + '.name',
				'achievements.' + c.achievement + '.description'
			]).then(function (strings) {
				$('#ticketMessages').append('<a name="' + c.id + '"></a><div id="message-' + c.id + '" class="box box-biggest item-top comment" data-id="' + c.id + '" style="overflow:visible;"><div class="account-box' + (c.online ? ' online' : ' offline') + '"><div class="avatar" style="background-image:url(' + c.avatar + ');"><a href="/' + c.username + '"></a></div>' + (c.achievement != 0 ? '<div class="achievement" rel="tooltip" data-name="' + strings[0] + '" data-description="' + strings[0] + '" style="background-image:url(/images/hexagon_grey.png), url(//cdn.habtium.com/achievements/' + c.achievement + '.png);"><a href="/' + c.username + '/achievements#' + c.achievement + '"></a></div>' : '') + '<div class="body"><span>' + (c.name != c.nick ? '<h1><a href="/' + c.username + '">' + c.name + '</h1></a> <i>' + c.nick + '</i>' : '<h1><a href="/' + c.username + '">' + c.nick + '</a></h1>') + '<h2>' + Time.getHTML(c.time) + '</h2></span></div></div><div class="body text">' + c.content + '</div></div>');
			});
		}

		if (!Tickets.loading) {
			Tickets.loading = true;
			Api.get('/tickets/ticket/' + id, {}, function (r){
				if (r.success) {
					// Ticket status and information
					$('#ticketInformation').append(`
						<div class="box box-biggest box-blueIris animated bounceInUp">
							<div class="head">Información de la solicitud #${id} <span class="glyphicons glyphicons-circle-info"></span></div>
							<div class="body flex" style="flex-direction:column;">
								<span><strong>Asunto:</strong> ${r.data.subject}</span>
								<span><strong>Creado:</strong> ${Time.getHTML(r.data.created_at)}</span>
								<span><strong>Estado:</strong> ${(r.data.closed==1 ? 'Resuelta' : 'Abierta')}</span>
							</div>

						</div>
					`);
					// Display first message
					$('#ticketDetail').append(`
						<div class="box box-biggest box-blueIris animated bounceInUp">
							<div class="head">Explicación de la solicitud <span class="glyphicons glyphicons-chat-conversation"></span></div>
							<div class="body text">${r.comments[0].content}</div>
						</div>
					`);
					// Show if ticket doesnt have response.
					if (r.comments.length==1) {
						$('#ticketMessages').append(
							`<div class="box box-biggest animated bounceInUp">
								<div class="body">
									<div class="message big blue">Aún no hay respuestas añadidas a esta solicitud.</div>
								</div>
							</div>
						`);
					}

					let totalComments = r.comments.length;
					// Check if no responses and lastResponse is not staff member or

					if (r.comments[totalComments-1].isStaff==0 || totalComments==1 || r.data.closed==1){
						$('#newReplySupport').remove();
					}

					// Check if ticket is closed
					if (r.data.closed==1) {
						$('#errors').append(`
							<div class="box box-biggest box-blueIris animated bounceInUp">
								<div class="body">
									<div class="message blue"><span class="glyphicons glyphicons-chat-conversation-lock"></span> Esta solictud de asistencia se encuentra cerrada. No pueden añadirse nuevos mensajes.</div>
								</div>
							</div>
						`);
					}

					// Load all comments
					for (var i = 1; i < r.comments.length; i++) {
						putComment(r.comments[i]);
					}
					Tickets.loading = false;
				} else {
					switch (r.error.identifier) {
						case 'ticket_not_found':
						case 'ticket_not_auth':
							window.location.href = '/support';
							break;
					}
				}
			});
			Tickets.loading = false;
		}
	},
	// Reply
	reply: function(ticket_id) {

		if(!Tickets.lock) {
			Tickets.lock = true;

			Api.post('/tickets/reply',  {
				ticket: ticket_id,
				message: $('#ticket_message').val()
			}, function (r){
				if (r.success) {
					// Clear ticket information
					$('#ticketInformation').empty();
					// CLear ticket details
					$('#ticketDetail').empty();
					// Clear comments.
					$('#ticketMessages').empty();
					Tickets.init(r.ticket_id);
				} else {
					console.log(r.error.identifier);
				}
			});
			Tickets.lock = false;
		}
	},
	// My tickets
	my: function() {
			Api.get('/tickets/my', {}, function (r){
				if (r.success) {
					$('#myTickets')
					for (var i = 0; i < r.data.length; i++) {
						$('#myTickets').append(
							`<div class="box box-biggest box-blueIris" id="ticket_${r.data[i].id}">
								<div class="body flex" style="justify-content: space-between;align-items: center;">
									<div style="display: flex;align-items: center;">
										<div style="width: 50px;height: 50px;background-color: hsla(187, 100%, 40%,1) !important;border-radius: 3px;color: white;display: flex;align-items: center;justify-content: center;font-weight: bold;font-size: 25px;"><span class="glyphicons glyphicons-chat-message"></span></div>
										<div style="margin-left: 10px;">
											<h1>${r.data[i].subject}</h1>
											<h2>${r.data[i].closed==1 ? 'Resuelta' : 'Abierta'}</h2>
										</div>
									</div>
									<a href="/support/ticket/${r.data[i].id}" class="button big green">Ver</a>
								</div>
							</div>`
						);
					}
				} else {
					switch (r.error.identifier) {
						case 'no_tickets':
							$('#myTickets').empty();
							$('#myTickets').append(
								`<div class="box box-biggest box-blueIris">
									<div class="body flex" style="justify-content: space-between;align-items: center;">
										<div class="message blue">No tienes solicitudes de asistencia creadas.</div>
									</div>
								</div>`
							);
							break;
					}
				}
			});
	}
}
